// Width of the web shopping-assistant side panel, in pixels. Shared (via
// useShoppingAssistantViewport) by the panel itself and the layout page-squeeze
// so the two can never drift.
// Wide (≥lg): the canonical width, matching the Figma design.
export const ASSISTANT_PANEL_WIDTH_PX = 375
// Narrow (md–lg): keeps the squeezed page usable on smaller desktops while
// staying wide enough for the chat (proven at phone widths in full-screen mode).
export const ASSISTANT_PANEL_NARROW_WIDTH_PX = 320
